var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrowser = function SvgBrowser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.667 1.667H8.333c-3.142 0-4.714 0-5.69.976-.975.977-.976 2.548-.976 5.69v.833q-.002.69.006 1.25h8.829c.086-.566.28-1.155.769-1.645.515-.515 1.142-.703 1.733-.782.539-.072 1.2-.072 1.921-.072h.15c.721 0 1.383 0 1.92.072.448.06.915.182 1.338.46v-.116c0-3.142 0-4.714-.976-5.69-.977-.976-2.548-.976-5.69-.976M2.399 13.433c.732.732 1.911.732 4.268.732h2.708V17.5H6.667a.625.625 0 0 0 0 1.25h4.625l-.021-.021c-.515-.515-.703-1.142-.782-1.733-.072-.539-.072-1.2-.072-1.921v-2.65c0-.415 0-.811.014-1.175H1.698c.059 1.048.227 1.71.701 2.184"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.334 12.5V15c0 1.572 0 2.357-.489 2.845-.488.488-1.273.488-2.845.488s-2.357 0-2.845-.488-.488-1.273-.488-2.845v-2.5c0-1.572 0-2.357.488-2.845.489-.489 1.274-.489 2.845-.489s2.357 0 2.845.489c.489.488.489 1.273.489 2.845m-4.792 4.166c0-.344.28-.625.625-.625h1.667a.625.625 0 0 1 0 1.25h-1.667a.625.625 0 0 1-.625-.625",
    clipRule: "evenodd"
  })));
};
export default SvgBrowser;